//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/NXObject.js";
let d=[[],[[[],"GetSegment",{R_:{segment:"Routing.SplineSegment"}},0,0],[[],"GetSBendRadius",{R_:{bend_radius:''}},0,0],[["num_stocks"],"GetSBendStocks",{R_:{stock:"Routing.Stock[]"}},0,0],[["sbend_type","start_rcp","end_rcp","segment","radius_or_ratio"],"GetSBendData",{R_:{use_bend_ratio:''}},0,0],[["sbend_type","start_rcp","end_rcp","segment","radius_or_ratio","use_bend_ratio"],"SetSBendData",{},6,0]],[]];
SPLM.Routing.SBendCorner = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.SBendCorner";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;